import { createRouter, createWebHistory } from 'vue-router'

import PeugeotContactUs from '../components/PeugeotContactUs.vue'
import PeugeotFinanceCalculator from '../components/PeugeotFinanceCalculator.vue'
import CitroenContactUs from '../components/CitroenContactUs.vue'
import CitroenFinanceCalculator from '../components/CitroenFinanceCalculator.vue'
import OpelContactUs from '../components/OpelContactUs.vue'
import OpelFinanceCalculator from '../components/OpelFinanceCalculator.vue'
import AppError from '../components/AppError.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: PeugeotFinanceCalculator
  },
  {
    path: '/peugeot',
    name: 'peugeot-finance-calculator',
    component: PeugeotFinanceCalculator
  },
  {
    path: '/peugeot/calculator',
    component: PeugeotFinanceCalculator
  },
  {
    path: '/peugeot/contact-us',
    name: 'peugeot-contact-us',
    component: PeugeotContactUs,
    props: true
  },
  {
    path: '/citroen',
    name: 'citroen-finance-calculator',
    component: CitroenFinanceCalculator
  },
  {
    path: '/citroen/calculator',
    component: CitroenFinanceCalculator
  },
  {
    path: '/citroen/contact-us',
    name: 'citroen-contact-us',
    component: CitroenContactUs,
    props: true
  },
  {
    path: '/opel',
    name: 'opel-finance-calculator',
    component: OpelFinanceCalculator
  },
  {
    path: '/opel/calculator',
    component: OpelFinanceCalculator
  },
  {
    path: '/opel/contact-us',
    name: 'opel-contact-us',
    component: OpelContactUs,
    props: true
  },
  {
    path: '/:catchAll(.*)',
    name: 'error',
    component: AppError
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export { routes }

export default router
